import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

export default function Analytics() {
  const location = useLocation();

  useEffect(() => {
    if (process.env.NODE_ENV === "development" && !process.env.REACT_APP_GA_MEASUREMENT_ID) {
      console.warn(
        "[Analytics] REACT_APP_GA_MEASUREMENT_ID is not set. If you just added it to .env, " +
        "restart the dev server — CRA only reads .env at startup."
      );
    }
  }, []);

  useEffect(() => {
    // console.log(process.env.REACT_APP_GA_MEASUREMENT_ID)
    window.gtag?.("event", "page_view", {
      page_path: location.pathname + location.search,
      page_title: document.title,
    });
  }, [location]);

  return null;
}